export default "__VITE_ASSET__LJHp4bqQ__"